import React from "react";
import HeroSwiper from "./HeroSwiper";

const Hero = () => {

  return (
    <section className="lg:min-h-screen flex flex-col items-center justify-center bg-landingPage ">
      <div className="text-center mb-8 grid gap-4 z-50">
        <h1 className="text-2xl md:text-4xl font-bold text-primary mb-4 mt-4">
          طاقات سورية ... نحو أثر مستدام
        </h1>
        <p className="text-base md:text-lg text-gray-700">
          المنصة الوطنية الرسمية للعمل التطوعي في سوريا بإشراف{" "}
          <strong className="text-primary">وزارة التنمية الإدارية</strong>
        </p>
      </div>

      <HeroSwiper />
    </section>
  );
};

export default Hero;
